import { BgColorOptions } from '@df/ui/atomic/atomic-options';
import { NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { CMS_COMPONENT_CWV_CONFIG } from '../../../../config/component.config';

export const PAGE_COMPONENT_GIFTCARDS_CONFIG = <Omit<NICmsContentComponent.IMeta<NICmsContentComponent.IComponent>, 'type'>>{
    id: 'giftcards',
    name: 'Giftcards landing page',
    tags: ['Giftcards', 'Giftcard'],
    fields: [
        <NICmsContentField.IField>{
            type: NICmsContentField.EFieldType.label,
            key: 'general',
            title: 'General'
        },
        <NICmsContentField.IField>{
            type: NICmsContentField.EFieldType.text,
            key: 'title',
            title: 'Title',
            required: true
        },
        <NICmsContentField.IField>{
            type: NICmsContentField.EFieldType.text,
            key: 'copy',
            title: 'Copy',
            required: true
        },
        <NICmsContentField.IRepeaterField>{
            type: NICmsContentField.EFieldType.repeater,
            key: 'items',
            title: 'Items',
            itemName: 'Item',
            itemNameField: 'cta_text',
            defaultSize: 2,
            maxSize: 2,
            fields: [
                <NICmsContentField.IField>{
                    key: 'image',
                    type: NICmsContentField.EFieldType.image,
                    title: 'Image',
                    required: true
                },
                <NICmsContentField.IField>{
                    key: 'cta_text',
                    type: NICmsContentField.EFieldType.text,
                    title: 'CTA Text',
                    required: true
                },
                <NICmsContentField.IField>{
                    key: 'cta_link',
                    type: NICmsContentField.EFieldType.text,
                    title: 'CTA Link',
                    required: true
                }
            ]
        },
        <NICmsContentField.IField>{
            type: NICmsContentField.EFieldType.label,
            key: 'balance-checker',
            title: 'Balance checker'
        },
        <NICmsContentField.IField>{
            type: NICmsContentField.EFieldType.text,
            key: 'balance_checker_title',
            title: 'Title',
            required: true,
            default: 'Gift Card Balance Checker'
        },
        <NICmsContentField.IField>{
            type: NICmsContentField.EFieldType.text,
            key: 'balance_checker_copy',
            title: 'Copy',
            required: true,
            default: 'Check how much money is on your gift card here.'
        },
        <NICmsContentField.IField>{
            key: 'balance_checker_cta_text',
            type: NICmsContentField.EFieldType.text,
            title: 'CTA Text',
            default: 'Check balance',
            required: true
        },
        <NICmsContentField.IChoiceField>{
            key: 'balance_checker_bg',
            type: NICmsContentField.EFieldType.choice,
            title: 'Background color',
            options: BgColorOptions,
            colorPreview: true,
            required: true
        },
        <NICmsContentField.IRepeaterField>{
            type: NICmsContentField.EFieldType.repeater,
            key: 'faqs',
            title: 'FAQs',
            itemName: 'FAQ item',
            fields: [
                <NICmsContentField.ITextField>{
                    key: 'question',
                    type: NICmsContentField.EFieldType.text,
                    title: 'Question',
                    required: true
                },
                <NICmsContentField.ITextField>{
                    key: 'answer',
                    type: NICmsContentField.EFieldType.text,
                    title: 'Answer',
                    required: true
                }
            ]
        },
        ...CMS_COMPONENT_CWV_CONFIG
    ]
};
